import { render, staticRenderFns } from "./JobCompanyComponent.vue?vue&type=template&id=91887f60&scoped=true"
import script from "./JobCompanyComponent.vue?vue&type=script&lang=ts"
export * from "./JobCompanyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91887f60",
  null
  
)

export default component.exports